// libraries
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { notification, Tabs } from 'antd';
import styled from 'styled-components';

// services
import * as ActivityService from '../../../../services/bb-api/activity';

// components
import { Spinner } from '../../../shared/spinner';
import { ActivityFormTab } from './tabs/activity-form-tab';
import { ActivityPageHeader } from './activity-page-header';
import { DatesTab } from './tabs/dates-tab';
import { ImageTab } from './tabs/image-tab';

import { txt } from '../../../../locales/i18n';

export function ActivityPage(): JSX.Element {
	const [activity, setActivity] = useState<any>();
	const [loading, setLoading] = useState<boolean>(true);
	const [activeTab, setActiveTab] = useState<string>('');

	const { id } = useParams<any>();
	const history = useHistory();
	const location = useLocation();

	useEffect(() => setActiveTab(location.hash), [location.hash]);

	useEffect(() => {
		async function getActivity(): Promise<void> {
			setLoading(true);

			try {
				const activity: Record<string, any> = await ActivityService.get(id);
				setActivity(activity);
			} catch (error) {
				history.replace('/activities');
				const message: string = (error as Error).name;
				const description: string = (error as Error).message;
				notification.error({ message, description });
			}

			setLoading(false);
		}

		getActivity();
	}, [id, history]);

	if (loading) return <Spinner text="Getting data..." />;

	return (
		<StyledMain>
			<ActivityPageHeader activity={activity} />

			<Tabs activeKey={activeTab} onChange={(hash) => history.replace({ hash })} className="tab-container">
				<Tabs.TabPane
					key=""
					tab={txt('global.activity')}
					children={<ActivityFormTab useActivity={[activity, setActivity]} />}
				/>

				<Tabs.TabPane
					key="#image"
					tab={txt('global.image')}
					children={<ImageTab useActivity={[activity, setActivity]} />}
				/>

				<Tabs.TabPane key="#dates" tab={txt('global.dates')} children={<DatesTab activity={activity} />} />
			</Tabs>
		</StyledMain>
	);
}

const StyledMain = styled.main`
	height: 100%;
	display: flex;
	flex-direction: column;

	.tab-container {
		overflow-y: auto;
		padding: 0 2rem;
	}
`;
